import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class ProgrammableLogicController_tote_checkingService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: {  }): 
  Promise<{ result: { Id?: number, PlcInstructions?: string, ToteContainerId?: number, TaskLookups?: { ToteGroupingId?: number, TaskId?: number }[] }[] }> 
  {
    let $url = `${environment.backendUrl}api/ProgrammableLogicController/datasources/tote_checking/get`;
    
    const $options = {
    }
    
    const $body = null;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, PlcInstructions?: string, ToteContainerId?: number, TaskLookups?: { ToteGroupingId?: number, TaskId?: number }[] }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/ProgrammableLogicController/datasources/tote_checking/getList`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { $keys: number[] }): 
  Promise<{ result: { Id?: number, PlcInstructions?: string, ToteContainerId?: number, TaskLookups?: { ToteGroupingId?: number, TaskId?: number }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/ProgrammableLogicController/datasources/tote_checking/getByKeys`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      }) {
      return false;
    }
}
